<ng-container *transloco="let t">
    <mat-form-field
        [dir]="lang === 'ar' ? 'rtl' : 'ltr'"
        class="relative fuse-mat-dense"
        [ngClass]="
            width === 'responsive'
                ? 'fuse-mat-rounded w-full min-w-52'
                : width === 'small-responsive'
                ? 'fuse-mat-rounded w-full min-w-44 sm:min-w-52'
                : width
                ? 'w-full'
                : 'fuse-mat-rounded min-w-52'
        "
        [subscriptSizing]="'dynamic'"
    >
        <mat-label
            *ngIf="label"
            >{{ label }}</mat-label
        >

        <ng-container *ngIf="tooltipInfo">
            <mat-icon
                class="absolute top-[-1.6rem] p-2 text-2xl"
                [ngClass]="lang === 'ar' ? 'left-0' : 'right-0'"
                [matTooltip]="tooltipInfo"
                >error_outline</mat-icon
            >
        </ng-container>

        <mat-select
            (selectionChange)="changeValue()"
            (openedChange)="onPanelOpenedChange($event)"
            [formControl]="formControl"
            [multiple]="multiple"
            placeholder="{{ placeholder }}"
        >
            <!-- Custom trigger: closed field shows primary/trigger label only.
                 Without this, single-select with subtitleField reuses the full
                 option content (e.g. name + department) inside the form field. -->
            <mat-select-trigger
                *ngIf="selectAll || subtitleField || triggerDisplayField"
            >
                {{ getDisplayText() }}
            </mat-select-trigger>
            <mat-option>
                <ngx-mat-select-search
                    [formControl]="filterCtrl"
                    [noEntriesFoundLabel]="t('No matching options found')"
                    [placeholderLabel]="t('Find option...')"
                ></ngx-mat-select-search>
            </mat-option>
            <mat-option 
                *ngIf="selectAll" 
                (click)="toggleSelectAll($event)"
                [value]="'__select_all__'"
                [class.mat-mdc-option-active]="isAllSelected()"
            >
                {{ t("Select All") }}
            </mat-option>
            <mat-option *ngIf="searchPlaceholder" [value]="0">
                {{ getAllOptionLabel() }}
            </mat-option>
            <!-- No `[selected]` binding on the option below. `MatOption.selected` is a read-only
                 getter, not an `@Input`, so binding it never did anything at runtime and Angular
                 reports it as NG0303 the moment this component is rendered inside a unit test.
                 Selection comes from the `formControl` value on the `mat-select` above, which is
                 where it has always actually come from. -->
            <mat-option
                *ngFor="let option of displayOptions; trackBy: trackByOption"
                [value]="option[valueField]"
                [disabled]="option.disabled"
            >
                <ng-container *ngIf="subtitleField; else singleLineOption">
                    <div class="flex flex-col leading-tight py-0.5">
                        <span>{{ getOptionLabel(option) }}</span>
                        <span
                            *ngIf="getOptionLabel(option, subtitleField)"
                            class="text-xs text-gray-500 dark:text-gray-400"
                        >
                            {{ getOptionLabel(option, subtitleField) }}
                        </span>
                    </div>
                </ng-container>
                <ng-template #singleLineOption>
                    {{ getOptionLabel(option) }}
                </ng-template>
            </mat-option>
            <mat-option
                *ngIf="serverSide && loadingMore"
                disabled
                class="mat-select-search-loading-option"
            >
                <div class="flex justify-center py-2">
                    <mat-progress-spinner diameter="24" mode="indeterminate"></mat-progress-spinner>
                </div>
            </mat-option>

        </mat-select>
    </mat-form-field>
</ng-container>
